import { render } from "./FranchiserView.vue?vue&type=template&id=96e7624c"
import script from "./FranchiserView.vue?vue&type=script&lang=js"
export * from "./FranchiserView.vue?vue&type=script&lang=js"

import "./FranchiserView.vue?vue&type=style&index=0&id=96e7624c&lang=css"

import exportComponent from "D:\\도연희\\vuestudy\\vuemasi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__